// Store Zustand per lo stato di autenticazione del portale clienti.
// Separato dallo store admin per evitare conflitti di sessione.
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PortalAuthState {
  accessToken: string | null
  companyId: string | null
  email: string | null
  companyName: string | null
  isAuthenticated: boolean
}

interface PortalAuthActions {
  setPortalAuth: (data: {
    accessToken: string
    companyId: string
    email: string
    companyName?: string
  }) => void
  clearPortalAuth: () => void
}

export const usePortalStore = create<PortalAuthState & PortalAuthActions>()(
  persist(
    (set) => ({
      // Stato iniziale
      accessToken: null,
      companyId: null,
      email: null,
      companyName: null,
      isAuthenticated: false,

      setPortalAuth: (data) =>
        set({
          accessToken: data.accessToken,
          companyId: data.companyId,
          email: data.email,
          companyName: data.companyName ?? null,
          isAuthenticated: true,
        }),

      clearPortalAuth: () =>
        set({
          accessToken: null,
          companyId: null,
          email: null,
          companyName: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'fc-portal-auth',
      // Persiste solo i dati essenziali di sessione
      partialize: (state) => ({
        accessToken: state.accessToken,
        companyId: state.companyId,
        email: state.email,
        companyName: state.companyName,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
